export default 
{
    camelToKebabCase: (camelText) => camelText.replace(/[A-Z]/g, letter => `-${letter.toLowerCase()}`),
}